const isSameYear = (date1, date2) => !!date1 && !!date2 && date1.getFullYear() === date2.getFullYear();
const isSameMonth = (date1, date2) => !!date1 && !!date2 && isSameYear(date1, date2) && date1.getMonth() === date2.getMonth();
const isSameDay = (date1, date2) => !!date1 && !!date2 && isSameYear(date1, date2) && isSameMonth(date1, date2) && date1.getDate() === date2.getDate();
const isFirstDayOfMonth = (date) => {
  const firstDate = new Date(date);
  firstDate.setDate(1);
  return isSameDay(firstDate, date);
};
const isLastDayOfMonth = (date) => {
  const lastDate = new Date(date);
  lastDate.setDate(1);
  lastDate.setMonth(date.getMonth() + 1);
  lastDate.setDate(0);
  return isSameDay(lastDate, date);
};
const isBetweenDays = (date, start, end) => {
  if (start && end) {
    date.setHours(0, 0, 0, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    return date > start && date < end;
  }
  return false;
};
const isWeekend = (date) => !!date && [0, 6].includes(date.getDay());
const getLocalMonth = (date, locale = "en-US") => date.toLocaleDateString(locale, {
  month: "short"
});
const getLocalYear = (date, locale = "en-US") => date.toLocaleDateString(locale, {
  year: "numeric"
});
const getLocalMonthYear = (date, locale = "en-US") => date.toLocaleDateString(locale, {
  month: "long",
  year: "numeric"
});
const getLocalDayOfWeek = (date, locale = "en-US") => date.toLocaleDateString(locale, {
  weekday: "narrow"
});
const getLocalStandardDate = (date, locale = "en-US") => date.toLocaleDateString(locale, {
  day: "numeric",
  month: "long",
  year: "numeric"
});
const getLocalContextualDateRange = (start, end, locale = "en-US") => {
  const startString = start.toLocaleDateString(locale, {
    day: "numeric",
    month: "long",
    year: !isSameYear(start, end) ? "numeric" : void 0
  });
  const endString = end.toLocaleDateString(locale, {
    day: "numeric",
    month: !isSameMonth(start, end) ? "long" : void 0,
    year: !isSameYear(start, end) ? "numeric" : void 0
  });
  return `${startString} - ${endString}`;
};
const getDaysArray = (month, firstDayOfWeek = 0) => {
  const array = [];
  if (month) {
    const day = new Date(month);
    day.setDate(1);
    day.setDate(1 - (day.getDay() + (7 - firstDayOfWeek)) % 7);
    for (let row = 0; row < 6; row++) {
      for (let col = 0; col < 7; col++) {
        const thisDay = new Date(day);
        array.push(thisDay);
        day.setDate(day.getDate() + 1);
      }
    }
  }
  return array;
};
const incrementToFirstOfMonth = (date, increment) => {
  const newDate = new Date(date);
  newDate.setDate(1);
  newDate.setMonth(newDate.getMonth() + increment);
  return newDate;
};
const stepDay = (date, increment) => new Date(date.setDate(date.getDate() + increment));
const mapDatesToOptions = (dates, type = "year", locale = "en-US") => dates.map(
  (date) => type === "month" ? {
    date,
    label: getLocalMonth(date, locale),
    value: date.getMonth().toString()
  } : {
    date,
    label: getLocalYear(date, locale),
    value: date.getFullYear().toString()
  }
);
export {
  getDaysArray,
  getLocalContextualDateRange,
  getLocalDayOfWeek,
  getLocalMonth,
  getLocalMonthYear,
  getLocalStandardDate,
  getLocalYear,
  incrementToFirstOfMonth,
  isBetweenDays,
  isFirstDayOfMonth,
  isLastDayOfMonth,
  isSameDay,
  isSameMonth,
  isSameYear,
  isWeekend,
  mapDatesToOptions,
  stepDay
};
